import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
import FilePreview from "../../../FilePreview/FilePreview";

const SortablePackageImage = ({
  image,
  index,
  moveImage,
  onDelete,
  label,
}) => {
  const containerRef = useRef(null);
  const dragHandleRef = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    type: "package-image",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: "package-image",
    hover(draggedItem) {
      if (draggedItem.index === index) return;
      moveImage(draggedItem.index, index);
      draggedItem.index = index;
    },
  });

  drag(dragHandleRef);
  drop(containerRef);

  return (
    <div
      ref={containerRef}
      className={`flex min-w-0 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition-all ${
        isDragging ? "opacity-60 shadow-md ring-2 ring-primary/20" : "hover:border-gray-300"
      }`}
    >
      <button
        ref={dragHandleRef}
        type="button"
        className="flex shrink-0 cursor-grab items-center justify-center border-r border-gray-100 bg-gray-50 px-2.5 active:cursor-grabbing"
        aria-label="Drag to reorder"
      >
        <i className="fi fi-rr-grip-dots-vertical text-base text-gray-400"></i>
      </button>

      <div className="min-w-0 flex-1">
        <FilePreview
          file={image.file || image}
          fileUrl={image.image_url}
          label={label}
          onDelete={onDelete}
          isImage={true}
          compact={true}
          embedded={true}
        />
      </div>
    </div>
  );
};

export default SortablePackageImage;
